import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody01, typeLabel01, typeBody03 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'

import { StyledLink, StyledButton } from '../../theme/components'


export const Inner = styled.div`
	${row({medium:true})}
	justify-content: center;
	align-items: center;
`

export const NextButton = styled(StyledButton)`
	margin-left: ${unit(3)};
`

export const PreviousButton = styled(StyledButton)`
	margin-right: ${unit(3)};
`

export const Pages = styled.p`
	${typeBody01}
	color: ${props => props.theme.foreground};
`